export default {
	"contactUs": {
		"title": "开设FCA账户，您将获得最权威的监管保护和最安全的资金保障，即刻开设",
		"title1": "每一个认真交易的人，都值得被认真对待。",
		"code": "验证码",
	},
	"dividend": {
		"title": "CFD 股息",
		"title1": "CFD 股息参考:",
		"desc": "*请注意：CFD 股息收取会在您的MT4账户上的余额里以存款或者取款形式反映出来，注释为 “Dividend”",
		"btn": "开始投资"
	},
	"notice": "近期我們發現EBC Group與一家提供線上加密貨幣產品名為“EBankc”的公司關聯起來了。<br/><br/>在此我們明確聲明，EBC Group的官方網站為 www.ebc.com  和 www.ebcfin. com ，頁面詳細介紹了我們所提供的產品資訊，並不包含加密貨幣。<br/><br/>同時，EBC Financial Group (UK) Ltd有且僅有一個官方網址 www.ebcfin.co.uk，並對所提供的產品進行了全面的介紹。 加密貨幣不是其中之一。<br/><br/>所有EBC集團公司均根據其經營所在司法管轄區的規則和法規運營，並將採取一切必要措施封锁任何協力廠商在未經授權的項目中使用其品牌。",
	"contact": {
		"title": "您的投资，就此启程",
		"pageTitle": "开户咨询",
		"pageEnTitle": "Inquiry",
		"name": "贵姓 | 称谓",
		"sexList": [{
			"label": "先生",
			"value": "sir"
		}, {
			"label": "女士",
			"value": "lady"
		}],
		"email": "联系电话或邮箱",
		"btn": "发送联系意愿",
		"tips1": "请输入您的称呼!",
		"tips2": "请输入您的联系方式!",
		"tips3": "留言成功!",
		"tips4": "请输入正确的验证码!"
	},
	"column1": {
		"placeholder": "全站搜索",
		"login": "客户登录",
		"langText": "EBC 网站地区/语言",
		"langList": [{
			"text": "繁体",
			"value": "zh_TW"
		}, {
			"text": "English",
			"value": "en_US"
		}, {
			"text": "한국어",
			"value": "ko_KR"
		}, {
			"text": "日本語",
			"value": "ja_JP"
		}, {
			"text": "ئۇيغۇر تىلى",
			"value": "weiwuer"
		}]
	},
	"linkList": [{
		"title": "账户&条件",
		"list": [{
			"label": "交易账户",
			"link": "/TradingAccount"
		}, {
			"label": "交易产品",
			"link": "/tradingproduct"
		}, {
			"label": "杠杆与保证金",
			"link": "/leverage-margin"
		},
		{
			"label": "出入金",
			"link": "/funding"
		},
		{
			"label": "股息",
			"link": "/dividend"
		}
		]
	}, {
		"title": "交易工具",
		"list": [{
			"label": "MT4下载",
			"link": "/MT4"
		}, {
			"label": "MT5下载",
			"link": "/MT5"
		},{
			"label": "MT4交易工具",
			"link": "/tools"
		}, {
			"label": "PAMM",
			"link": "/PAMM"
		},{
			"label": "市场分析",
			"link": "/market-analysis"
		}
		]
	}, {
		"title": "EBC研究院",
		"list": [{
			"label": "学习中心",
			"link": "/LearningCenter"
		}, {
			"label": "数据中心",
			"link": "/lab"
		}
		]
	}, {
		"title": "最新活动",
		"list": [{
			"label": "积分商城",
			"link": "PointsMall"
		}, {
			"label": "百万美金交易大赛",
			"link": "/win"
		},
		// {
		// 	"label": "挑战最强交易环境",
		// 	"link": "/no1"
		// },
		 {
			"label": "创作者激励计划",
			"link": "/cfa"
		}, {
			"label": "领取订单流工具",
			"link": "/orderflow"
		}, {
			"label": "交易领薪计划",
			"link": "/pay"
		}]
	}, {
		"title": "合作伙伴",
		"list": [{
			"label": "影响力联盟",
			"link": "/affiliate-programmes"
		}, {
			"label": "机构服务",
			"link": "/service"
		}, {
			"label": "底层科技",
			"link": "/technology"
		}]
	}, {
		"title": "关于EBC",
		"list": [{
			"label": "EBC介绍",
			"link": "/about-us"
		}, {
			"label": "法律文件",
			"link": "/LegalDocumen"
		}, {
			"label": "社会责任",
			"link": "/ESG"
		}, {
			"label": "帮助中心",
			"link": "https://support.ebchelp.com/hc/zh-cn"
		}, {
			"label": "官方渠道验证",
			"link": "/official-verification"
		}]
	}],
	"headlist": [{
		"text": "首页",
		"url": "/"
	}, {
		"text": "交易",
		"menu": [{
			"text": "交易产品",
			"url": "/tradingproduct"
		}, {
			"text": "交易账户",
			"url": "/TradingAccount"
		}, {
			"text": "交易条件",
			"menu": [{
				"text": "出入金",
				"url": "/funding"
			}, {
				"text": "杠杆与保证金",
				"url": "/leverage-margin"
			}]
		}, {
			"text": "交易平台",
			"menu": [{
				"text": "MT4",
				"url": "/MT4"
			}, {
				"text": "MAM",
				"url": "/MAM"
			}, {
				"text": "PAMM",
				"url": "/PAMM"
			},{
				"text": "市场分析",
				"url": "/market-analysis"
			}]
		}, {
			"text": "股息",
			"url": "/dividend"
		}]
	}, {
		"text": "LAB与工具",
		"menu": [{
			"text": "学习中心",
			"url": "/LearningCenter"
		}, {
			"text": "数据中心",
			"url": "/lab"
		}, {
			"text": "交易工具",
			"url": "/tools"
		}]
	}, {
		"text": "机构合作",
		"menu": [{
			"text": "底层科技",
			"url": "/technology"
		}, {
			"text": "机构服务",
			"url": "/service"
		}, {
			"text": "合作伙伴",
			"url": "/partner"
		}]
	}, {
		"text": "最新活动",
		"menu": [{
			"text": "领取订单流工具",
			"url": "/orderflow"
		}, {
			"text": "限时优享免息",
			"url": "/FreeSwap"
		}, {
			"text": "交易领薪计划",
			"url": "/pay"
		}]
	}, {
		"text": "关于EBC",
		"menu": [{
			"text": "Why EBC",
			"url": "/about-us"
		}, {
			"text": "FAQ",
			"url": "https://support.ebchelp.com/hc/zh-cn"
		}]
	}, {
		"text": "交易大赛",
		"url": "/win"
	}, {
		"text": "跟单社区",
		"url": "/from0tohero"
	}, {
		"text": "免费开户",
		"url": "https://client.myebc.co/signup?bid=5s71xp"
	}],
	"login": "登录",
	"zhuce": "免费开户",
	"gendan": "跟单社区",
	"pdfLang": "cn",
	"bannerLang": "cn",
	"language": "简体中文",
	"className": "zh-box",
	"text": "EBC金融集团是由以下公司集团共享的联合品牌：<br>EBC Financial Group (SVG) LLC 获批于圣文森特与格林纳丁斯金融服务管理局授权和监管，注册号为353 LLC 2020。<br>其他相关实体<br>EBC Financial Group (UK) Limited获批英国金融行为监管局授权和监管，监管号为927552。网址：<a style=\"color:#fff\" target=\"_blank\" href=\"https://www.ebcfin.co.uk\" rel=\"nofollow\">www.ebcfin.co.uk</a><br>EBC Financial Group (Australia) Pty Ltd（公司编号：619 073 237）由澳大利亚证券和投资委员会授权并监管（监管编号：500991）。EBC Financial Group (Australia) Pty Ltd 是 EBC Financial Group (SVG) LLC 的关联实体，两个实体独立运营管理。本网站提供的金融产品和服务并非由澳大利亚公司实体提供，且不涉及澳大利亚实体的责任。<br>EBC Financial Group (Cayman) Limited获得开曼群岛金融管理局许可并受其监管，监管号为2038223。网址： <a style=\"color:#fff\" target=\"_blank\" href=\"https://www.ebcgroup.ky\" rel=\"nofollow\">www.ebcgroup.ky</a><br>公司地址：The Leadenhall Building, 122 Leadenhall Street, London, United Kingdom, EC3V 4AB 邮件地址：cs@ebc.com 电话：+44 20 3376 9662<br>免责声明：EBC金融集团明确不参与任何虚拟货币业务或者提供虚拟货币CFD服务。我们的金融服务只针对传统金融产品。客户须知，如有用EBC名义推荐虚拟货币有关服务，一律视为误导，且未经授权。 任何过去的表现都不代表未来表现，网站所含内容只供参考，不构成任何投资建议。<br>地区限制：EBC不向以下地区的居民提供服务，阿富汗、白俄罗斯、缅甸、加拿大、中非共和国、刚果、古巴、刚果民主共和国、厄立特里亚、海地、伊朗、伊拉克、黎巴嫩、利比亚、马来西亚、马里、朝鲜（朝鲜民主主义人民共和国）、俄罗斯、索马里、苏丹、南苏丹、叙利亚、乌克兰（包括克里米亚、顿涅茨克和卢甘斯克地区）、美国、委内瑞拉和也门。了解更多信息，请查阅我们的常见问题解答。<br>合规披露：公司网站在全球范围内可见，不针对任何实体。您的权力和义务由您选择地区的监管以及实体决定。当地法律和监管可能禁止或者限制你进入、下载、传播、分享或者使用网站上发布的任何文档和信息。<br>高风险交易产品披露：CFD是复杂的金融产品，使用杠杆代表着迅速亏损的高风险。保证金交易蕴含高风险，可能不适用于所有投资者。您应该结合自身目标、财务情况和风险偏好来衡量上述信息。您可能损失一部分或者所有本金。我们建议您寻求独立意见，确保您在进行投资决策前充分理解其中风险。在交易前，请仔细阅读相关风险披露声明。",
	"waptext": "EBC金融集团是由以下公司集团共享的联合品牌：<br>EBC Financial Group (SVG) LLC 获批于圣文森特与格林纳丁斯金融服务管理局授权和监管，注册号为353 LLC 2020。<br>其他相关实体<br>EBC Financial Group (UK) Limited获批英国金融行为监管局授权和监管，监管号为927552。网址：<a style=\"color:#fff\" target=\"_blank\" href=\"https://www.ebcfin.co.uk\" rel=\"nofollow\">www.ebcfin.co.uk</a><br>EBC Financial Group (Australia) Pty Ltd（公司编号：619 073 237）由澳大利亚证券和投资委员会授权并监管（监管编号：500991）。EBC Financial Group (Australia) Pty Ltd 是 EBC Financial Group (SVG) LLC 的关联实体，两个实体独立运营管理。本网站提供的金融产品和服务并非由澳大利亚公司实体提供，且不涉及澳大利亚实体的责任。<br>EBC Financial Group (Cayman) Limited获得开曼群岛金融管理局许可并受其监管，监管号为2038223。网址： <a style=\"color:#fff\" target=\"_blank\" href=\"https://www.ebcgroup.ky\" rel=\"nofollow\">www.ebcgroup.ky</a><br>公司地址：The Leadenhall Building, 122 Leadenhall Street, London, United Kingdom, EC3V 4AB 邮件地址：cs@ebc.com 电话：+44 20 3376 9662<br>免责声明：EBC金融集团明确不参与任何虚拟货币业务或者提供虚拟货币CFD服务。我们的金融服务只针对传统金融产品。客户须知，如有用EBC名义推荐虚拟货币有关服务，一律视为误导，且未经授权。 任何过去的表现都不代表未来表现，网站所含内容只供参考，不构成任何投资建议。<br>地区限制：EBC不向以下地区的居民提供服务，阿富汗、白俄罗斯、缅甸、加拿大、中非共和国、刚果、古巴、刚果民主共和国、厄立特里亚、海地、伊朗、伊拉克、黎巴嫩、利比亚、马来西亚、马里、朝鲜（朝鲜民主主义人民共和国）、俄罗斯、索马里、苏丹、南苏丹、叙利亚、乌克兰（包括克里米亚、顿涅茨克和卢甘斯克地区）、美国、委内瑞拉和也门。了解更多信息，请查阅我们的常见问题解答。<br>合规披露：公司网站在全球范围内可见，不针对任何实体。您的权力和义务由您选择地区的监管以及实体决定。当地法律和监管可能禁止或者限制你进入、下载、传播、分享或者使用网站上发布的任何文档和信息。<br>高风险交易产品披露：CFD是复杂的金融产品，使用杠杆代表着迅速亏损的高风险。保证金交易蕴含高风险，可能不适用于所有投资者。您应该结合自身目标、财务情况和风险偏好来衡量上述信息。您可能损失一部分或者所有本金。我们建议您寻求独立意见，确保您在进行投资决策前充分理解其中风险。在交易前，请仔细阅读相关风险披露声明。"
}